import React from 'react';
import { Card } from 'antd';

import type { ProjectType } from '../../types/project';

interface ProjectTypeSelectionProps {
  onProjectTypeSelect: (projectType: ProjectType) => void;
  onCancel: () => void;
  createType: 'project' | 'version';
}

const ProjectTypeSelection: React.FC<ProjectTypeSelectionProps> = ({
  onProjectTypeSelect,
  onCancel,
  createType,
}) => (
  <div className='container py-4'>
    <a className='cancel-link' onClick={onCancel}>
      <svg
        aria-hidden='true'
        focusable='false'
        role='presentation'
        width='24'
        height='24'
        viewBox='0 0 53 53'
        fill='black'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M41.9587 14.1554L38.8449 11.0416L26.5003 23.3862L14.1557 11.0416L11.042 14.1554L23.3866 26.5L11.042 38.8445L14.1557 41.9583L26.5003 29.6137L38.8449 41.9583L41.9587 38.8445L29.6141 26.5L41.9587 14.1554Z'
          stroke='none'
        />
      </svg>
    </a>
    <h3 className='heading mb-4'>Choose {createType} type</h3>
    <div className='d-flex flex-direction-row cards-wrapper justify-content-center'>
      <div>
        <Card hoverable onClick={() => onProjectTypeSelect('blueprint')} className='card'>
          <img src='/blueprints.png' alt='blueprints' width={340} height={340} />
          <div className='card-bottom'>
            <h5>I have Blueprints</h5>
            <p>Upload existing blueprints and get takeoff estimates</p>
          </div>
        </Card>
      </div>
      <div>
        <Card hoverable onClick={() => onProjectTypeSelect('design')} className='card'>
          <img src='/custom-design.png' alt='design' width={340} height={340} />
          <div className='card-bottom'>
            <h5>Design my Space</h5>
            <p>Create a design from scratch using our design tool</p>
          </div>
        </Card>
      </div>
    </div>
  </div>
);

export default ProjectTypeSelection;
